import { venueStatus } from '@/constants'

const mixin = {
  computed: {
    venueStatuses () {
      const statuses = []

      for (const prop in venueStatus) {
        const id = venueStatus[prop]
        let name

        switch (id) {
          case venueStatus.ok:
            name = this.$t('venueStatus.ok')
            break
          case venueStatus.cancelled:
            name = this.$t('venueStatus.cancelled')
            break
          case venueStatus.notConfirmed:
            name = this.$t('venueStatus.notConfirmed')
            break
        }

        statuses.push({
          id,
          name
        })
      }
      return statuses
    }
  },


  methods: {
    getVenueStatusById (statusId) {
      return this.venueStatuses.find(el => el.id === statusId)
    }
  }
}

export default mixin
